import React from "react";
//#region types
//#endregion
//#region components
import useFileViewerContext from "./context/useContext";
//#endregion

function useFilePreviewOnDialog(showLeft?: boolean) {
  const dialogRef = React.useRef<HTMLDivElement>();
  const filePreviewRef = React.useRef<HTMLDivElement>();
  const { currentFileDimensions, containerDimensions, setContainerDimensions } = useFileViewerContext();

  const minMarginOuter = 32;
  const gapWithImagePreview = 24;
  const maxWindowWidth = 1920;

  const handleResize = () => {
    const data = currentFileDimensions;
    const dialog: HTMLDivElement | null | undefined = dialogRef?.current?.querySelector(".MuiDialog-paper");
    const preview = filePreviewRef.current;

    if (data) {
      if (dialog) {
        const dialogWidth = dialog?.clientWidth ?? 0;
        const viewAreaWidth = window.innerWidth > maxWindowWidth ? maxWindowWidth : window.innerWidth;
        const previewMaxWidth = viewAreaWidth - dialogWidth - minMarginOuter * 2 - gapWithImagePreview;
        const previewMaxHeight = window.innerHeight - minMarginOuter * 2;

        let previewHeight = previewMaxHeight;
        let previewWidth = previewMaxWidth;

        if (data.height && data.width) {
          if (previewMaxHeight >= previewMaxWidth) {
            previewWidth = previewMaxWidth;
            previewHeight = (data.height * previewMaxWidth) / data.width;

            if (previewHeight > previewMaxHeight) {
              previewWidth = (data.width * previewMaxHeight) / data.height;
              previewHeight = previewMaxHeight;
            }
          } else {
            previewWidth = (data.width * previewMaxHeight) / data.height;
            previewHeight = previewMaxHeight;

            if (previewWidth > previewMaxWidth) {
              previewWidth = previewMaxWidth;
              previewHeight = (data.height * previewMaxWidth) / data.width;
            }
          }
        } else {
          previewWidth = previewHeight / 1.42;
        }

        setContainerDimensions({ width: previewWidth, height: previewHeight });

        const dialogRight = (previewWidth + gapWithImagePreview) / 2;
        const previewRight = (window.innerWidth - (dialogWidth + previewWidth + gapWithImagePreview)) / 2;
        const previewTop = dialog.offsetTop + previewHeight < window.innerHeight ? dialog.offsetTop : minMarginOuter;

        if (!dialogWidth) return;

        if (previewWidth + dialogWidth > viewAreaWidth || previewMaxWidth < 400) {
          preview?.setAttribute("style", `display: none`);
          dialog.setAttribute("style", `${showLeft ? "left" : "right"}: auto`);
        } else {
          preview?.setAttribute("style", `display: block`);
          dialog.setAttribute("style", `${showLeft ? "left" : "right"}: ${dialogRight}px`);
          if (previewWidth > 0 || previewRight > 200)
            preview?.setAttribute(
              "style",
              `width: ${previewWidth}px; height:${previewHeight}px; max-width: none; max-height: none; ${
                showLeft ? "left" : "right"
              }: ${previewRight}px; top: ${previewTop}px`
            );
        }
      }
    } else {
      dialog?.setAttribute("style", `right: auto`);
    }
  };

  React.useEffect(() => handleResize(), [currentFileDimensions]);

  React.useEffect(() => {
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [currentFileDimensions]);

  const assignRef = (divElement: HTMLDivElement) => {
    dialogRef.current = divElement;
  };

  const assignPreviewRef = (divElement: HTMLDivElement) => {
    filePreviewRef.current = divElement;
  };

  return { assignPreviewRef, assignRef, containerDimensions };
}

export default useFilePreviewOnDialog;
